import { supabase } from '../lib/supabase'

export const getFileUrl = async (filePath: string | null, bookCode: string | null): Promise<string | null> => {
    if (!filePath) return null

    try {
        // Construct the full path: {book.code}/{question.file}
        const fullPath = bookCode ? `${bookCode}/${filePath}` : filePath

        const { data, error } = await supabase.storage
            .from('files')
            .createSignedUrl(fullPath, 3600) // URL valid for 1 hour

        if (error) throw error
        return data.signedUrl
    } catch (err) {
        console.error('Failed to get file URL:', err)
        return null
    }
}
